import { Link } from 'react-router-dom';
import type { PageSummary } from '../services/api';

interface BreadcrumbProps {
  appSlug: string;
  appName: string;
  items: PageSummary[];
}

const Breadcrumb = ({ appSlug, appName, items }: BreadcrumbProps) => (
  <nav className="flex flex-wrap items-center gap-1.5 text-sm" aria-label="Breadcrumb">
    <Link to="/" className="text-neutral-300 no-underline hover:text-white">
      All apps
    </Link>
    <span className="text-neutral-500">/</span>
    <Link to={`/${appSlug}`} className="text-neutral-300 no-underline hover:text-white">
      {appName}
    </Link>
    {items.map((item, index) => {
      const isLast = index === items.length - 1;
      const path = items
        .slice(0, index + 1)
        .map((c) => c.slug)
        .join('/');
      return (
        <span key={item.slug} className="flex items-center gap-1.5">
          <span className="text-neutral-500">/</span>
          {isLast ? (
            <span className="font-medium text-neutral-100">{item.title}</span>
          ) : (
            <Link to={`/${appSlug}/${path}`} className="text-neutral-300 no-underline hover:text-white">
              {item.title}
            </Link>
          )}
        </span>
      );
    })}
  </nav>
);

export default Breadcrumb;
